import * as types from '../actions/action-types';

export function getSrchParams(data) {
  return {
    type: types.GET_SEARCH_PARAMS,
    data
  };
}

export function getSearchResults(data) {
  return {
    type: types.GET_SEARCH_RES,
    data
  };
}

export function updateSearchResults(data) {
  return {
    type: types.UPDATE_BUS,
    data
  };
}

export function updateFilterTime(data) {
  return {
    type: types.UPDATE_FILTER_TIME,
    data
  };
}

export function updateFilterCoach(data) {
  return {
    type: types.UPDATE_FILTER_COACH,
    data
  };
}

export function updateFilterJourneyType(data) {
  return {
    type: types.UPDATE_FILTER_JOURNEY_TYPE,
    data
  };
}

export function updateFilterAmen(data) {
  return {
    type: types.UPDATE_FILTER_AMEN,
    data
  };
}

export function updateFilterBusService(data) {
  return {
    type: types.UPDATE_FILTER_BUS_SERVICE,
    data
  };
}



export function updateFilterReset() {
  return {
    type: types.UPDATE_FILTER_RESET
  };
}

export function updateSeatChart(rsid, data) {
  return {
    type: types.UPDATE_SEAT_CHART,
    rsid, data
  };
}

export function updateSeatChartDet(rsid, data) {
  return {
    type: types.UPDATE_SEAT_CHART_DET,
    rsid, data
  };
}

export function updateBusImage(rsid, data) {
  return {
    type: types.UPDATE_BUS_IMAGE,
    rsid, data
  };
}

export function updateTripDetail(rsid, data) {
  return {
    type: types.UPDATE_TRIP_DET,
    rsid, data
  };
}

export function updateCheckoutDet(data) {
  return {
    type: types.UPDATE_CHECKOUT_DET,
    data
  };
}

export function updateOrderToken(data) {
  return {
    type: types.UPDATE_ORDER_TOKEN,
    data
  };
}

export function updateContactDetails(data) {
  // console.log({ data })
  return {
    type: types.UPDATE_CONTACT_DETAIL,
    data
  };
}

export function updateUserInfo(info, param, seat, data) {
  let type;
  switch (info) {
    case 'name':
      type = types.UPDATE_USER_NAME
      break;
    case 'age':
      type = types.UPDATE_USER_AGE
      break;
    case 'gender':
      type = types.UPDATE_USER_GENDER
      break;
    case 'concessionType':
      type = types.UPDATE_USER_CONCESSIONTYPE
      break;
    case 'idCardNo':
      type = types.UPDATE_USER_IDCARDNO
      break;
    case 'idCardType':
      type = types.UPDATE_USER_IDCARDTYPE
      break;
    case 'nationality':
      type = types.UPDATE_USER_NATIONALITY
      break;
    default:
      break;
  }
  return {
    type, param, seat, data
  }
}

export function updateUserName(param, seat, data) {
  return {
    type: types.UPDATE_USER_NAME,
    param, seat, data
  };
}

export function updateUserAge(param, seat, data) {
  return {
    type: types.UPDATE_USER_AGE,
    param, seat, data
  };
}

export function updateUserGender(param, age, data) {
  return {
    type: types.UPDATE_USER_GENDER,
    param, age, data
  };
}

export function couponListDetails(data) {
  return {
    type: types.UPDATE_COUPON_LIST,
    data
  }
}


export function updateLoader(data) {
  return {
    type: types.UPDATE_LOADER,
    data
  };
}
export function updateHeaderText(text) {
  return {
    type: types.UPDATE_HEADER_TEXT,
    text
  };
}

export function updatemiddleRoute(rsid, data) {
  return {
    type: types.UPDATE_MIDDLE_ROUTE,
    rsid, data
  };
}

export function updateSortBy(data) {
  return {
    type: types.UPDATE_SORT_BY,
    data
  };
}

export function updateServiceTypeFilter(data) {
  return {
    type: types.UPDATE_SERVICE_TYPE_FILTER,
    data
  };
}

export function updateSeatChartErrorMsg(rsid, msg) {
  return {
    type: types.UPDATE_SEATCHART_ERROR_MSG,
    rsid, msg
  };
}

export function updatePathDtls(rsid, data) {
  return {
    type: types.UPDATE_PATH_DTLS,
    rsid, data
  };
}

export function updateRouteCodeDtls(rsid, data) {
  return {
    type: types.UPDATE_ROUTECODE_DTLS,
    rsid, data
  };
}

export function updateBusServiceType(busType) {
  return {
    type: types.UPDATE_BUS_SERVICE_TYPE,
    busType
  }
}

export function updateTripCode(data) {
  return {
    type: types.UPDATE_TRIP_CODE,
    data
  }
}

export function updateRoutesPkpDrp(data) {
  return {
    type: types.UPDATE_ROUTES_PKPDRP,
    data
  };
}

export function updateFilterBoardingPoint(data) {
  return {
    type: types.UPDATE_FILTER_BOARDING_POINT,
    data
  };
}

export function updateFilterDroppingPoint(data) {
  return {
    type: types.UPDATE_FILTER_DROPPING_POINT,
    data
  };
}

export function updateFareRange(data) {
  return {
    type: types.UPDATE_FARE_RANGE,
    data
  };
}

export function updateFilterPriceRange(data) {
  return {
    type: types.UPDATE_FILTER_PRICE,
    data
  };
}

export function updateFilterLayoverRange(data) {
  return {
    type: types.UPDATE_FILTER_LAYOVER,
    data
  };
}

export function updateLevyAndConcession(data, id) {
  return {
    type: types.UPDATE_LEVY_CONCESSION,
    data, id
  };
}

export function updateShowpassenger(data) {
  return {
    type: types.UPDATE_SHOW_PASSENGER,
    data
  };
}

export function updatePnrEnqiryData(data) {
  return {
    type: types.UPDATE_PNR_ENQUIRY_DATA,
    data
  };
}

export function updatePnrEnqiryTripData(data) {
  return {
    type: types.UPDATE_PNR_ENQUIRY_TRIPDATA,
    data
  };
}

export function updateLoginData(data) {
  return {
    type: types.UPDATE_LOGIN_DATA,
    data
  };
}

export function updateRecaptchaToken(token) {
  return {
    type: types.UPDATE_CAPTCHA_TOKEN,
    token
  };
}

export function updateStaticCityList(data) {
  return {
    type: types.UPDATE_SATATIC_CITY_LIST,
    data
  };
}

export function updateCityList(data) {
  return {
    type: types.UPDATE_CITY_LIST,
    data
  };
}

export function updatePackageData(data){
  return {
    type: types.UPDATE_PACKAGE_DATA,
    data
  };
}

export function updatePackageCity(data){
  return {
    type: types.UPDATE_PACKAGE_CITY,
    data
  };
}

export function updatePackageCategory(data){
  return {
    type: types.UPDATE_PACKAGE_CATEGORY,
    data
  };
}
export function updatePackageTour(data){
  return {
    type: types.UPDATE_PACKAGE_TOUR,
    data
  };
}


export function updateLinkedCityData(data) {
  return {
    type: types.UPDATE_LINKED_CITY_DATA,
    data
  };
}


export function getReturnSearchResults(data) {
  return {
    type: types.GET_RETURN_SEARCH_RES,
    data
  };
}

export function updateReturnSearchResults(data) {
  return {
    type: types.UPDATE_RETURN_BUS,
    data
  };
}

